export function formatGender(gender) {
  const genderMapping = {
    'male': 'Masculino',
    'female': 'Feminino',
    'other': 'Outro'
  };
  return genderMapping[gender] || gender;
}

export function formatCompanyType(companyType) {
  const companyTypeMapping = {
    'mei' : 'MEI',
    'limited': 'Limitada',
    'individual': 'Individual',
    'association': 'Associação',
  };
  return companyTypeMapping[companyType] || companyType;
}

export function formatPartnerType(partnerType) {
  const partnerTypeMapping = {
    'partner_in': 'Interno',
    'partner_out': 'Externo',
  };
  return partnerTypeMapping[partnerType] || partnerType;
}